import { css, jsx } from '@emotion/react';
import { Alert, Link } from '@zapier/design-system';
import { baseReset } from '../../../../utils/style-mixins/reset';
import { labelStyles } from '@zapier/style-encapsulation';
export const shouldRender = (data) => {
    const { currentAccount } = data;
    return (currentAccount.isTrialingEnterprise &&
        currentAccount.enterpriseTrialEndDate &&
        currentAccount.currentUserRole &&
        ['owner', 'admin', 'super_admin'].includes(currentAccount.currentUserRole));
};
const Styles = labelStyles('EnterpriseTrialing', {
    content: css `
    ${baseReset};
  `,
});
export const Component = function EnterpriseTrialing(props) {
    const { data } = props;
    const { currentAccount } = data;
    const { enterpriseTrialEndDate } = currentAccount;
    const title = 'Welcome to your Enterprise trial';
    const formattedEndDate = new Date(enterpriseTrialEndDate)
        .toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })
        .replace(/([a-z]+)/i, '$1.');
    return (jsx(Alert, { variant: props.variant, title: title, status: "info" },
        jsx("p", { "data-zds": true, css: Styles.content },
            `You will have access until ${formattedEndDate}. `,
            jsx(Link, { href: "https://zapier.com/enterprise" }, "Learn more"),
            " about Enterprise or",
            ' ',
            jsx(Link, { href: "https://zapier.com/l/contact-sales?demo_source=enterprise-trial-banner-logged-in" }, "contact Sales"),
            ' ',
            "to upgrade.")));
};
//# sourceMappingURL=EnterpriseTrialing.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
